export default __webpack_public_path__ + "static/media/Construction.8e5b1ef9.png";